import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { runsListSearchSchema } from '~/features/catalog-v2/types/runs.types';

const FeedAuditListPage = lazy(() => import('~/features/catalog-v2/pages/feed-audit-list-page'));

/** Feed audits on catalog-service: the run list pinned to FEED_AUDIT. The same search schema as
 *  Batches (status tab, page, size) so Back restores it; `flow` is ignored — the page pins it. */
export const Route = createFileRoute('/_authenticated/_tenant/catalog-v2/feed-audit/')({
  validateSearch: runsListSearchSchema,
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <FeedAuditListPage />
    </Suspense>
  ),
});
